import React from "react";
import { Box } from "@mui/material";
import AccessRulesTable from "../components/accessRules/AccessRulesTable";
import AccessLogsTable from "../components/accessLogs/AccessLogsTable";

export const AccessRules: React.FC = () => {
  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <AccessRulesTable />
      <AccessLogsTable />
    </Box>
  );
};

export default AccessRules;
